import { FC } from "react"

export const ReactIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg width="38" height="35" viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="38" height="35" rx="4" fill="#F7F7F7" />
      <g clipPath="url(#clip0_176_1608)">
        <path
          d="M18.9999 19.4608C20.0829 19.4608 20.9608 18.5829 20.9608 17.4999C20.9608 16.417 20.0829 15.5391 18.9999 15.5391C17.917 15.5391 17.0391 16.417 17.0391 17.4999C17.0391 18.5829 17.917 19.4608 18.9999 19.4608Z"
          fill="#979797"
        />
        <path
          d="M18.9998 21.5174C24.8108 21.5174 29.5215 19.7188 29.5215 17.5001C29.5215 15.2813 24.8108 13.4827 18.9998 13.4827C13.1888 13.4827 8.47803 15.2813 8.47803 17.5001C8.47803 19.7188 13.1888 21.5174 18.9998 21.5174Z"
          stroke="#979797"
          strokeWidth="0.956522"
        />
        <path
          d="M15.5208 19.5086C18.4263 24.5411 22.3393 27.7214 24.2608 26.612C26.1823 25.5027 25.3846 20.5237 22.4791 15.4912C19.5736 10.4588 15.6606 7.27847 13.7391 8.38785C11.8176 9.49722 12.6153 14.4762 15.5208 19.5086Z"
          stroke="#979797"
          strokeWidth="0.956522"
        />
        <path
          d="M15.5206 15.4912C12.6151 20.5237 11.8174 25.5026 13.7388 26.612C15.6603 27.7213 19.5734 24.541 22.4789 19.5086C25.3844 14.4761 26.1821 9.49716 24.2606 8.38779C22.3391 7.27842 18.426 10.4587 15.5206 15.4912Z"
          stroke="#979797"
          strokeWidth="0.956522"
        />
      </g>
      <defs>
        <clipPath id="clip0_176_1608">
          <rect width="22" height="20" fill="white" transform="translate(8 7.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

